import React, { createContext, useContext, useReducer, useEffect } from 'react';
import { getUniqueKey } from 'helpers/utils/KeyUtils';

// const initialState = {count: 0, message: ""};

const COUNTDOWN_PROVIDER_REFRESH_GLOBAL: string =
  'COUNTDOWN_PROVIDER_REFRESH_GLOBAL' + getUniqueKey();
export const COUNTDOWN_PROVIDER_ADD: string = 'COUNTDOWN_PROVIDER_ADD';
export const COUNTDOWN_PROVIDER_REMOVE: string = 'COUNTDOWN_PROVIDER_REMOVE';

export interface CountdownProviderInitialState {
  globalCounter: number;
  counters: {
    [key: string]: {
      key: string;
      startCounter: number;
      startGlobalCounter: number;
    };
  };
}

const INITAL_STATE: CountdownProviderInitialState = {
  globalCounter: 0,
  counters: {},
};

export interface CountdownProviderRefreshGlobalAction {
  type: typeof COUNTDOWN_PROVIDER_REFRESH_GLOBAL;
  counter: number;
}

export interface CountdownProviderAddAction {
  type: typeof COUNTDOWN_PROVIDER_ADD;
  key: string;
  startCounter: number;
}

export interface CountdownProviderRemoveAction {
  type: typeof COUNTDOWN_PROVIDER_REMOVE;
  key: string;
}

export type CountdownProviderActionTypes =
  | CountdownProviderRefreshGlobalAction
  | CountdownProviderAddAction
  | CountdownProviderRemoveAction;

const CountdownStoreContext = createContext({
  state: INITAL_STATE,
  dispatch: (any: any) => any,
});

const reducer = (
  state: CountdownProviderInitialState,
  action: CountdownProviderActionTypes
): CountdownProviderInitialState => {
  switch (action.type) {
    case COUNTDOWN_PROVIDER_REFRESH_GLOBAL:
      return {
        ...state,
        globalCounter: (action as CountdownProviderRefreshGlobalAction).counter,
      };
    case COUNTDOWN_PROVIDER_ADD:
      return {
        ...state,
        counters: {
          ...state.counters,
          [(action as CountdownProviderAddAction).key]: {
            key: (action as CountdownProviderAddAction).key,
            startCounter: (action as CountdownProviderAddAction).startCounter,
            startGlobalCounter: state.globalCounter,
          },
        },
      };
    case COUNTDOWN_PROVIDER_REMOVE:
      return {
        ...state,
        ...((): CountdownProviderInitialState => {
          const newState = { ...state };
          delete newState.counters[
            (action as CountdownProviderRemoveAction).key
          ];
          return newState;
        })(),
      };
    default:
      return state;
  }
};

export interface CountdownProviderProps {
  children: React.ReactNode;
}

export default function CountdownProvider({
  children,
}: CountdownProviderProps) {
  const [state, dispatch] = useReducer(reducer, INITAL_STATE);

  useEffect(() => {
    const interval = setInterval(() => {
      dispatch({
        type: COUNTDOWN_PROVIDER_REFRESH_GLOBAL,
        counter: state.globalCounter + 1,
      });
    }, 1000);
    return () => clearInterval(interval);
  });

  return (
    <CountdownStoreContext.Provider
      value={{
        state,
        dispatch,
      }}
    >
      {children}
    </CountdownStoreContext.Provider>
  );
}

export const useCountdownStore = () => useContext(CountdownStoreContext);
